
export default function Trust() {
  const reasons = [
    {
      icon: 'ri-money-dollar-circle-line',
      title: '圧倒的なコストパフォーマンス',
      description:
        '数千万円の機械を守る保険料が、1本あたり1日約7円（5年使用換算）。',
      color: 'text-green-600',
      bgColor: 'bg-green-50',
    },
    {
      icon: 'ri-leaf-line',
      title: '環境・人体への安全性',
      subtitle: 'PFASフリー',
      description:
        '健康と環境に配慮した水系消火剤を使用。※一部化学物質を使っています。ISO14001（環境）取得工場でも安心して導入できます。',
      color: 'text-teal-600',
      bgColor: 'bg-teal-50',
    },
    {
      icon: 'ri-tools-fill',
      title: 'メンテナンスフリー',
      description:
        '5年間、点検不要。液剤が容器に触れない二重構造で腐食リスクなし。管理の手間をゼロに。',
      color: 'text-blue-600',
      bgColor: 'bg-blue-50',
    },
  ];

  return (
    <section className="trust-section py-16 md:py-24 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-16">
          <div className="inline-block bg-indigo-100 text-indigo-600 px-4 py-2 rounded-full text-sm font-semibold mb-4 md:mb-6">
            選ばれる理由
          </div>
          <h2 className="trust-heading text-3xl md:text-5xl font-bold text-gray-900 mb-4 md:mb-6" style={{ lineHeight: '1.5' }}>
            <span className="trust-line1">なぜ厳しい安全基準を持つ</span>
            <br />
            <span className="trust-line2">製造現場で採用されるのか？</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-8 mb-10 md:mb-16">
          {reasons.map((reason, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl shadow-lg p-6 md:p-8 hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2"
            >
              <div className={`${reason.bgColor} rounded-2xl p-4 md:p-6 mb-4 md:mb-6`}>
                <div className="flex items-center justify-center mb-3 md:mb-4">
                  <div className="w-12 h-12 md:w-16 md:h-16 bg-white rounded-full flex items-center justify-center shadow-md">
                    <i className={`${reason.icon} text-3xl md:text-4xl ${reason.color}`}></i>
                  </div>
                </div>
                <div className="text-center">
                  <h3 className="text-lg md:text-xl font-bold text-gray-900 mb-1 md:mb-2">{reason.title}</h3>
                  {reason.subtitle && (
                    <p className={`text-sm font-semibold ${reason.color}`}>{reason.subtitle}</p>
                  )}
                </div>
              </div>
              <p className="text-sm text-gray-700 leading-relaxed text-center">
                {reason.description}
              </p>
            </div>
          ))}
        </div>

        <div className="bg-gradient-to-r from-indigo-50 to-purple-50 rounded-3xl p-7 md:p-14">
          <div className="text-center mb-6 md:mb-8">
            <div className="w-16 h-16 md:w-20 md:h-20 bg-indigo-600 rounded-full flex items-center justify-center mx-auto mb-4 md:mb-6">
              <i className="ri-shield-star-line text-3xl md:text-4xl text-white"></i>
            </div>
            <h3 className="text-2xl md:text-3xl font-bold text-gray-900 mb-3 md:mb-4">プロが選ぶ、確かな理由</h3>
            <p className="text-base md:text-lg text-gray-700 max-w-3xl mx-auto">
              コスト、安全性、メンテナンス性。全ての面で優れたFIRE
              OUTは、製造業の現場で求められる全ての条件を満たしています。
            </p>
          </div>

          <div className="grid grid-cols-3 gap-3 md:gap-6">
            <div className="bg-white rounded-xl p-4 md:p-6 text-center">
              <p className="text-3xl md:text-4xl font-bold text-green-600 mb-1 md:mb-2">¥7</p>
              <p className="text-xs md:text-sm text-gray-700">1日あたりのコスト</p>
            </div>
            <div className="bg-white rounded-xl p-4 md:p-6 text-center">
              <p className="text-3xl md:text-4xl font-bold text-teal-600 mb-1 md:mb-2">5年</p>
              <p className="text-xs md:text-sm text-gray-700">メンテナンス不要</p>
            </div>
            <div className="bg-white rounded-xl p-4 md:p-6 text-center">
              <p className="trust-heat-value text-3xl md:text-4xl font-bold text-blue-600 mb-1 md:mb-2">90℃</p>
              <p className="text-xs md:text-sm text-gray-700">耐熱性能</p>
            </div>
          </div>
        </div>
      </div>

      <style>{`
        @media (max-width: 768px) {
          .trust-section {
            padding-top: 2rem !important;
          }
          .trust-heading {
            font-size: 1.5rem !important;
            line-height: 1.3 !important;
          }
          .trust-line1,
          .trust-line2 {
            display: block;
            white-space: nowrap;
          }
          .trust-cost-title {
            white-space: nowrap;
            font-size: 0.95rem !important;
          }
          .trust-heat-value {
            font-size: 1.5rem !important;
          }
        }
      `}</style>
    </section>
  );
}
